import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  defer,
  firstValueFrom,
  interval,
  map,
  of,
  share,
  startWith,
  Subscription,
  switchMap,
  tap,
} from 'rxjs';

import { BaseService } from '../base.service';

@Injectable({ providedIn: 'root' })
export class HealthService extends BaseService {
  private readonly healthUrl = `${this.baseUrl}/health`;
  private http = inject(HttpClient);
  private pollingSub?: Subscription;

  private isBackendDownSubject = new BehaviorSubject<boolean>(false);
  isBackendDown$ = this.isBackendDownSubject.asObservable();

  private readonly healthCheck$ = defer(() => this.http.get(this.healthUrl, { responseType: 'text' })).pipe(
    map(() => false),
    catchError(() => of(true)),
    tap((isDown) => this.setBackendDown(isDown)),
    map(() => undefined),
    share()
  );

  startHealthCheckPolling(ms: number = 30000): void {
    if (this.pollingSub) return;

    this.pollingSub = interval(ms)
      .pipe(
        startWith(0),
        switchMap(() => this.checkHealth())
      )
      .subscribe();
  }

  stopHealthCheckPolling(): void {
    this.pollingSub?.unsubscribe();
    this.pollingSub = undefined;
  }

  checkHealth(): Promise<void> {
    return firstValueFrom(this.healthCheck$);
  }

  markForCheck(): void {
    void this.checkHealth();
  }

  private setBackendDown(isDown: boolean) {
    if (this.isBackendDownSubject.value !== isDown) {
      this.isBackendDownSubject.next(isDown);
    }
  }
}
